import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Flame, Settings2 } from 'lucide-react';
import { Card, ProgressBar } from './ui';
import './HabitCard.css';

const GOALS = [
  { key: 'lessons', label: 'Aulas', week: 'lessons' },
  { key: 'questions', label: 'Questões', week: 'questions' },
  { key: 'flashcards', label: 'Flashcards', week: 'flashcards' },
];

/** Intensidade do dia no mapa de calor (escala sequencial de uma cor). */
function level(total) {
  if (!total) return 0;
  if (total < 5) return 1;
  if (total < 15) return 2;
  if (total < 40) return 3;
  return 4;
}

/** Sequência de dias, metas da semana e mapa dos últimos 28 dias. */
function HabitCard({ activity, goals }) {
  const navigate = useNavigate();
  if (!activity) return null;
  const hasGoals = GOALS.some(g => goals?.[g.key]);
  const days = activity.lastDays || [];

  return (
    <Card padding="lg" className="habit">
      <div className="habit__left">
        <div className="habit__head">
          <div className={`habit__streak ${activity.streak > 0 ? 'is-on' : ''}`}>
            <Flame size={24} aria-hidden="true" />
            <div>
              <span className="habit__streak-num">{activity.streak}</span>
              <span className="habit__streak-label">{activity.streak === 1 ? 'dia seguido' : 'dias seguidos'}</span>
            </div>
          </div>
          <span className={`habit__chip ${activity.studiedToday ? 'is-done' : ''}`}>
            {activity.studiedToday ? 'Você já estudou hoje' : activity.streak > 0 ? 'Estude hoje para manter' : 'Comece uma sequência hoje'}
          </span>
        </div>

        <div className="habit__heat" role="img" aria-label={`Atividade nos últimos ${days.length} dias`}>
          {days.map(d => (
            <span
              key={d.date}
              className={`habit__cell habit__cell--${level(d.total)}`}
              title={`${new Date(d.date + 'T12:00:00').toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit' })}: ${d.total} ${d.total === 1 ? 'atividade' : 'atividades'}`}
            />
          ))}
        </div>
        <div className="habit__legend" aria-hidden="true">
          <span>
            últimos {days.length} dias · recorde {activity.longestStreak} {activity.longestStreak === 1 ? 'dia' : 'dias'}
          </span>
          <span className="habit__legend-scale">
            menos {[0, 1, 2, 3, 4].map(l => <span key={l} className={`habit__cell habit__cell--${l}`} />)} mais
          </span>
        </div>
      </div>

      <span className="habit__divider" aria-hidden="true" />

      <div className="habit__goals">
        <div className="habit__goals-head">
          <span>Metas da semana</span>
          <button type="button" className="ss-iconbtn" onClick={() => navigate('/conta')} aria-label="Configurar metas">
            <Settings2 size={16} />
          </button>
        </div>
        {hasGoals ? GOALS.filter(g => goals[g.key]).map(g => {
          const done = activity.week[g.week];
          const goal = goals[g.key];
          return (
            <div key={g.key} className="habit__goal">
              <div className="habit__goal-row">
                <span>{g.label}</span>
                <strong>{done}<span>/{goal}</span></strong>
              </div>
              <ProgressBar value={(done / goal) * 100} label={`${g.label}: ${done} de ${goal}`} />
            </div>
          );
        }) : (
          <p className="habit__nogoals">
            Defina metas semanais em <button type="button" onClick={() => navigate('/conta')}>Minha conta</button> para acompanhar aqui.
          </p>
        )}
      </div>
    </Card>
  );
}

export default HabitCard;
